import Checkbox from '@mui/material/Checkbox';
import { formatDate } from 'utils/commonUtils';
import Typography from '@mui/material/Typography';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const ssaStudentColumns = (
  selectedIds = [],
  handleToggleSelect,
  handleSelectAll,
  allRows = []
) => [
  {
    field: 'select',
    headerName: '',
    width: 60,
    sortable: false,
    disableColumnMenu: true,
    align: 'center',
    headerAlign: 'center',
    renderHeader: () => {
      const allSelected =
        allRows?.length > 0 && selectedIds?.length === allRows?.length;
      const partiallySelected =
        selectedIds?.length > 0 && selectedIds?.length < allRows?.length;

      return (
        <Checkbox
          checked={allSelected}
          indeterminate={partiallySelected}
          onChange={(e) => handleSelectAll(e?.target?.checked)}
        />
      );
    },
    renderCell: (params) => (
      <Checkbox
        checked={selectedIds.includes(params?.row?.id)}
        onChange={(e) =>
          handleToggleSelect(params?.row?.id, e?.target?.checked)
        }
      />
    ),
  },
  {
    headerName: 'Student ID',
    field: 'studentNumber',
    width: 150,
  },
  {
    headerName: 'First Name',
    field: 'firstName',
    width: 150,
    renderCell: (params) => {
      const studentName = params.row.firstName;
      return <Typography variant="base">{studentName}</Typography>;
    },
  },

  {
    headerName: 'Last Name',
    field: 'lastName',
    width: 150,
    sortable: true,
    renderCell: (params) => {
      const studentName = params.row.lastName;
      return <Typography variant="base">{studentName}</Typography>;
    },
  },
  { headerName: 'Grade', field: 'gradeLevel', width: 150 },
  { headerName: 'Student Type', field: 'studentType', width: 150 },
  { headerName: 'Tags', field: 'tags', width: 150 },
  {
    headerName: 'Courses',
    field: 'courses',
    align: 'center',
    width: 150,
    renderCell: renderCellExpand,
  },
  { headerName: 'Iep Teacher', field: 'iepTeacher', width: 150 },
  { headerName: 'isActive', field: 'isActive', type: 'boolean', width: 150 },
];

export const getSsaStudentProfileListData = (studentProfileListData) => {
  const items = studentProfileListData?.items;
  if (!items || items.length === 0) {
    return [];
  }
  return items.map(
    ({
      resourceId,
      version,
      lastName,
      firstName,
      studentNumber,
      gradeLevel,
      studentType,
      courses,
      stateId,
      homePrimaryLanguage,
      raceEthnicity,
      gender,
      dateOfBirth,
      isActive,
      lastActiveSemester,
      dateLastActive,
      hasIepPlan,
      iepTeacher,
      note,
      noteUpdatedAt,
      noteUpdatedBy,
      createdAt,
      updatedAt,
      tags,
    }) => ({
      id: resourceId,
      resourceId,
      version,
      firstName,
      lastName,
      name: `${firstName} ${lastName}`,
      studentNumber,
      gradeLevel,
      studentType,
      stateId,
      courses: courses?.map((course) => course.courseName).join(', '),
      // courses: courses.length,
      coursesData: courses,
      homePrimaryLanguage,
      raceEthnicity,
      gender,
      dateOfBirth: formatDate(dateOfBirth),
      isActive,
      lastActiveSemester: lastActiveSemester,
      dateLastActive: dateLastActive,
      hasIepPlan,
      iepTeacher,
      note,
      noteUpdatedAt: formatDate(noteUpdatedAt),
      noteUpdatedBy,
      createdAt: formatDate(createdAt),
      updatedAt: formatDate(updatedAt),
      tags: tags?.join(', '),
    })
  );
};
